import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import About from '../About/About';
import Resume from '../Resume/Resume';
import Portfolio from '../Portfolio/Portfolio';
import Services from '../Services/Services';
import Testimonials from '../Testimonials/Testimonials';
import Blog from '../Blog/Blog';
import Contact from '../Contact/Contact';

const ContentTabs = () => {

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ }}>
            <Container maxWidth='xl'>
                <TabContext value={value} >
                    <Box sx={{ mt: { xs: '310px', sm: '450px', md: '170px', lg: '150px' } }}>
                        {/* <Box > */}
                        <TabList onChange={handleChange} sx={[

                            {
                                '& .MuiTabs-indicator': {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    backgroundColor: 'transparent',
                                },
                                p: 0, m: 0
                            },


                        ]}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"

                        >


                            <Tab label="About" icon={<HistoryEduIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            }]}
                                color='#fff' value="1" />


                            <Tab label="Resume" icon={<AssignmentIndIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="2" />


                            <Tab label="Portfolio" icon={<BusinessCenterIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="3" />

                            <Tab label="Service" icon={<BusinessCenterIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="4" />

                            <Tab label="Testimonial" icon={<BusinessCenterIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="5" />

                            <Tab label="Blog" icon={<BusinessCenterIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="6" />

                            <Tab label="Contact" icon={<BusinessCenterIcon sx={{ fontSize: { xs: '25px', md: '40px' } }} />} iconPosition="start" component={Paper} elevation={3} sx={[{ backgroundColor: '#fff', textTransform: 'capitalize', fontSize: { xs: '14px', md: '20px' }, color: 'primary.main', mx: { xs: .5, md: 1 }, p: { xs: 1, md: 4 }, my: 1, borderRadius: '8px' },
                            {
                                '&.Mui-selected': {
                                    color: '#fff',
                                    backgroundColor: 'primary.main'
                                }
                            },]}
                                color='#fff' value="7" />


                        </TabList>
                    </Box>
                    <Box sx={{}}>
                        <TabPanel value="1" sx={{ px: 0 }}><About /></TabPanel>
                        <TabPanel value="2" sx={{ px: 0 }}><Resume /></TabPanel>
                        <TabPanel value="3" sx={{ px: 0 }}><Portfolio /></TabPanel>
                        <TabPanel value="4" sx={{ px: 0 }}><Services /></TabPanel>
                        <TabPanel value="5" sx={{ px: 0 }}><Testimonials /></TabPanel>
                        <TabPanel value="6" sx={{ px: 0 }}><Blog /></TabPanel>
                        <TabPanel value="7" sx={{ px: 0 }}><Contact /></TabPanel>
                    </Box>
                </TabContext>
            </Container>
        </Box>
    );
};

export default ContentTabs;